import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Heart } from 'lucide-react';
import { Button } from '../components/ui/button';
import { ProductCard } from '../components/ProductCard';
import { useAuth } from '../contexts/AuthContext';
import { API_URL, getAuthHeaders } from '../lib/utils';

export const Wishlist = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    if (!user) {
      navigate('/login');
      return;
    }
    fetchWishlist();
  }, [user]);

  const fetchWishlist = async () => {
    try {
      const wishlistResponse = await axios.get(`${API_URL}/wishlist`, {
        headers: getAuthHeaders(),
      });

      if (wishlistResponse.data.product_ids && wishlistResponse.data.product_ids.length > 0) {
        const productRequests = wishlistResponse.data.product_ids.map((id) =>
          axios.get(`${API_URL}/products/${id}`)
        );
        const productResponses = await Promise.all(productRequests);
        setProducts(productResponses.map((r) => r.data));
      }
    } catch (error) {
      console.error('Failed to fetch wishlist:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p>Loading...</p>
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className="min-h-screen flex items-center justify-center px-6 bg-purple-25" data-testid="empty-wishlist">
        <div className="text-center">
          <Heart className="mx-auto h-16 w-16 text-stone-400 mb-4" />
          <h2 className="text-3xl font-heading font-light mb-4">Your Wishlist is Empty</h2>
          <p className="text-stone-600 mb-8">Save your favorite products for later!</p>
          <Button onClick={() => navigate('/shop')} className="rounded-full">
            Discover Products
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen py-12 px-6 lg:px-12 bg-purple-25" data-testid="wishlist-page">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-heading font-light mb-12">
          My Wishlist
        </h1>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </div>
  );
};